import React, { Component } from 'react';

class PhasorDiagram extends Component {
  constructor(props) {
    super(props);
    let phasorData = {
      r_current: { rI_Mag: 0, rI_Ph: 0 },
      y_current: { yI_Mag: 0, yI_Ph: 0 },
      b_current: { bI_Mag: 0, bI_Ph: 0 },
      r_voltage: { rV_Mag: 0, rV_Ph: 0 },
      y_voltage: { yV_Mag: 0, yV_Ph: 0 },
      b_voltage: { bV_Mag: 0, bV_Ph: 0 },
    };

    if (this.props.phasorData !== undefined) {
      phasorData = this.props.phasorData;
    }

    let r_voltage = phasorData.r_voltage;
    let y_voltage = phasorData.y_voltage;
    let b_voltage = phasorData.b_voltage;
    let r_current = phasorData.r_current;
    let y_current = phasorData.y_current;
    let b_current = phasorData.b_current;
    this.myRef = React.createRef();
    this.state = {
      offsetX: 75,
      offsetY: 35,
      outerRadius: 145,
      // magnitudes
      rVoltageMagnitude: r_voltage.rV_Mag,
      yVoltageMagnitude: y_voltage.yV_Mag,
      bVoltageMagnitude: b_voltage.bV_Mag,
      rCurrentMagnitude: r_current.rI_Mag,
      yCurrentMagnitude: y_current.yI_Mag,
      bCurrentMagnitude: b_current.bI_Mag,
      // angles
      rVoltageAngle: r_voltage.rV_Ph,
      yVoltageAngle: y_voltage.yV_Ph,
      bVoltageAngle: b_voltage.bV_Ph,
      rCurrentAngle: r_current.rI_Ph,
      yCurrentAngle: y_current.yI_Ph,
      bCurrentAngle: b_current.bI_Ph,
    };
  }

  render() {
    // Variables for centering Phasor diagram
    const { offsetX, offsetY, outerRadius } = this.state;
    const centerPointX = offsetX + outerRadius;
    const centerPointY = offsetY + outerRadius;
    const stepRadius = outerRadius / 3;

    // Extract Angle values
    const {
      rVoltageAngle,
      yVoltageAngle,
      bVoltageAngle,
      rCurrentAngle,
      yCurrentAngle,
      bCurrentAngle,
    } = this.state;
    // Extract Magnitude values
    let {
      rVoltageMagnitude,
      yVoltageMagnitude,
      bVoltageMagnitude,
      rCurrentMagnitude,
      yCurrentMagnitude,
      bCurrentMagnitude,
    } = this.state;

    // Normalize magniture values for rendering
    let vFactor = 0,
      iFactor = 0;
    const maxVoltage = Math.max(
      rVoltageMagnitude,
      yVoltageMagnitude,
      bVoltageMagnitude
    );
    const maxCurrent = Math.max(
      rCurrentMagnitude,
      yCurrentMagnitude,
      bCurrentMagnitude
    );
    if (maxVoltage > 0) vFactor = this.state.outerRadius / maxVoltage;
    if (maxCurrent > 0) iFactor = (this.state.outerRadius * 0.5) / maxCurrent;

    // Scaled magnitudes (rho)
    rVoltageMagnitude = rVoltageMagnitude * vFactor;
    yVoltageMagnitude = yVoltageMagnitude * vFactor;
    bVoltageMagnitude = bVoltageMagnitude * vFactor;
    rCurrentMagnitude = rCurrentMagnitude * iFactor;
    yCurrentMagnitude = yCurrentMagnitude * iFactor;
    bCurrentMagnitude = bCurrentMagnitude * iFactor;

    // Text rearrangement
    // console.log('ryb V angles',rVoltageAngle,yVoltageAngle,bVoltageAngle); // for debug
    // console.log('ryb I angles',rCurrentAngle,yCurrentAngle,bCurrentAngle); // for debug
    let adjustTextVY = { r: 0, y: 0, b: 0 };
    let adjustTextIY = { r: 0, y: 0, b: 0 };
    if (
      Math.abs(rVoltageAngle - yVoltageAngle) < 10 ||
      Math.abs(rVoltageAngle - bVoltageAngle) < 10 ||
      Math.abs(yVoltageAngle - bVoltageAngle) < 10
    ) {
      adjustTextVY.r += 20;
      adjustTextVY.y += 50;
      adjustTextVY.b += 80;
    }
    if (
      Math.abs(rCurrentAngle - yCurrentAngle) < 20 ||
      Math.abs(rCurrentAngle - bCurrentAngle) < 20 ||
      Math.abs(yCurrentAngle - bCurrentAngle) < 20
    ) {
      adjustTextIY.r += 20;
      adjustTextIY.y += 50;
      adjustTextIY.b += 80;
    }

    return (
      <div
        style={{
          position: 'relative',
          top: '0px',
          left: '0px',
          width: '480px',
          height: '400px',
        }}
      >
        {' '}
        <center
          style={{
            fontSize: '16px',
            fontWeight: '400',
            fontFamily: 'Lucida Sans Unicode',
            color: '#333',
            padding: '5px',
          }}
        >
          Phasor Diagram
          <svg
            width="480px"
            height="400px"
            style={{ border: '1px solid none', display: 'block' }}
          >
            {this.initPhasor(
              centerPointX,
              centerPointY,
              this.state.outerRadius,
              stepRadius
            )}
            {/* Voltage Vectors */}
            {this.drawVector(
              centerPointX,
              centerPointY,
              rVoltageMagnitude,
              this.state.rVoltageAngle,
              'red',
              '1',
              'Voltage',
              this.state.rVoltageMagnitude + 'V',
              adjustTextVY.r
            )}
            {this.drawVector(
              centerPointX,
              centerPointY,
              yVoltageMagnitude,
              this.state.yVoltageAngle,
              '#DDB60C',
              '1',
              'Voltage',
              this.state.yVoltageMagnitude + 'V',
              adjustTextVY.y
            )}
            {this.drawVector(
              centerPointX,
              centerPointY,
              bVoltageMagnitude,
              this.state.bVoltageAngle,
              'blue',
              '1',
              'Voltage',
              this.state.bVoltageMagnitude + 'V',
              adjustTextVY.b
            )}

            {/* Current Vectors */}
            {this.drawVector(
              centerPointX,
              centerPointY,
              rCurrentMagnitude,
              this.state.rCurrentAngle,
              'red',
              '1',
              'Current',
              this.state.rCurrentMagnitude + 'A',
              adjustTextIY.r
            )}
            {this.drawVector(
              centerPointX,
              centerPointY,
              yCurrentMagnitude,
              this.state.yCurrentAngle,
              '#DDB60C',
              '1',
              'Current',
              this.state.yCurrentMagnitude + 'A',
              adjustTextIY.y
            )}
            {this.drawVector(
              centerPointX,
              centerPointY,
              bCurrentMagnitude,
              this.state.bCurrentAngle,
              'blue',
              '1',
              'Current',
              this.state.bCurrentMagnitude + 'A',
              adjustTextIY.b
            )}
          </svg>
        </center>
      </div>
    );
  }

  pol2cart = function (rho, phi) {
    phi = phi * 0.01745;
    let x = rho * Math.cos(phi);
    let y = rho * Math.sin(phi);
    return { x, y };
  };

  pol2cartLabel = function (rho, phi) {
    let phiOrig = phi;
    phi = phi * 0.01745;
    let x = rho * Math.cos(phi);
    let y = rho * Math.sin(phi);

    if (phiOrig > 0 && phiOrig < 180) {
      y += 10;
    }
    if (phiOrig > 180 && phiOrig < 360) {
      y -= 5;
    }
    if (phiOrig > 90 && phiOrig < 270) {
      x -= 25;
    }
    return { x, y };
  };

  drawVector = function (
    x1,
    y1,
    magnitude,
    angle,
    colour,
    vectorWeight,
    entityType,
    labelText,
    adjustTextY
  ) {
    let arrowStyle = entityType === 'Voltage' ? true : false;
    let vectorEnd = this.pol2cart(magnitude, angle);
    let x2 = x1 + vectorEnd.x;
    let y2 = y1 + vectorEnd.y;
    // Arranging text position
    let tx = 0; // arrange tx accouding to x2 position, if adjustTextY > 0 (small angle difference) set tx near circumference depednding on arrowStyle;
    tx = adjustTextY > 0 ? (arrowStyle ? x1 + 145 : x1 + 72) : x2 + 15;
    let ty = 0; // add adjustTextY to y1 or y2 based on whether tx uses x1 or x2
    ty =
      adjustTextY > 0
        ? tx === x2 + 15
          ? y2 + adjustTextY
          : y1 + adjustTextY
        : y2;
    return (
      <g>
        <line
          x1={x1}
          id="vectorLine"
          y1={y1}
          x2={x2}
          y2={y2}
          stroke={colour}
          strokeWidth={vectorWeight}
        ></line>

        {this.drawArrow(x2, y2, angle, colour, vectorWeight, arrowStyle)}
        <text x={tx} y={ty} stroke={colour} style={{ fontSize: '12px' }}>
          {labelText}
        </text>
      </g>
    );
  };

  drawArrow = function (x, y, angle, colour, arrowWeight, open) {
    //console.log(angle-90-45);
    let arrowTopEnd = this.pol2cart(5, angle - 90 - 45);
    let arrowTopEndX = x + arrowTopEnd.x;
    let arrowTopEndY = y + arrowTopEnd.y;
    let arrowBottomEnd = this.pol2cart(5, angle + 90 + 45);
    let arrowBottomEndX = x + arrowBottomEnd.x;
    let arrowBottomEndY = y + arrowBottomEnd.y;
    let polySpec = ` ${arrowTopEndX},${arrowTopEndY} ${x},${y} ${arrowBottomEndX},${arrowBottomEndY}`;
    //console.log(arrowTopEnd,arrowBottomEnd);
    return (
      <g>
        {open ? (
          <polyline
            points={polySpec}
            style={{ fill: 'none', stroke: colour, strokeWidth: arrowWeight }}
          />
        ) : (
          <polygon
            points={polySpec}
            style={{ fill: colour, stroke: colour, strokeWidth: arrowWeight }}
          />
        )}
      </g>
    );
  };

  initPhasor = function (centerPointX, centerPointY, outerRadius, stepRadius) {
    const angleRange = Array.from({ length: 12 }, (v, k) => (k * 360) / 12);
    const angleLabelRange = Array.from(
      { length: 12 },
      (v, k) => (k * 360) / 12
    );
    const angleLabelStyle = {
      fontSize: '12px',
      fontFamily: 'Lucida Sans Unicode',
      fontWeight: 200,
      color: '#F0F0F0',
    };
    const legendStyle = {
      fontSize: '12px',
      fontFamily: 'Lucida Sans Unicode',
      fontWeight: 700,
      color: '#000',
    };
    //console.log('centerPointY',centerPointY);
    return (
      <g>
        <circle
          cx={centerPointX}
          cy={centerPointY}
          r={outerRadius}
          stroke="#AAA"
          strokeWidth="1"
          fill="none"
        />
        <circle
          cx={centerPointX}
          cy={centerPointY}
          r={outerRadius - stepRadius}
          stroke="#F0F0F0"
          strokeWidth="1"
          fill="none"
        />
        <circle
          cx={centerPointX}
          cy={centerPointY}
          r={outerRadius - 2 * stepRadius}
          stroke="#F0F0F0"
          strokeWidth="1"
          fill="none"
        />
        {angleRange.map((angle, index) => {
          return (
            <line
              key={`line-${index}`}
              x1={centerPointX}
              y1={centerPointY}
              x2={centerPointX + this.pol2cart(outerRadius, angle).x}
              y2={centerPointY + this.pol2cart(outerRadius, angle).y}
              stroke="#F0F0F0"
              strokeWidth="1"
            />
          );
        })}

        {angleLabelRange.map((angle, index) => {
          return (
            <text
              key={index}
              x={centerPointX + this.pol2cartLabel(outerRadius, angle).x}
              y={centerPointY + this.pol2cartLabel(outerRadius, angle).y}
              style={angleLabelStyle}
            >
              {angle}&deg;
            </text>
          );
        })}
        {/* Show Legends Static adjust w.r.t. centerPointXY */}
        {this.drawArrow(
          centerPointX - 145,
          centerPointY + 180,
          0,
          'red',
          2,
          true
        )}
        <text x={centerPointX - 140} y={centerPointY + 185} style={legendStyle}>
          Vr
        </text>
        {this.drawArrow(
          centerPointX - 145 + 50,
          centerPointY + 180,
          0,
          '#DDB60C',
          1,
          true
        )}
        <text
          x={centerPointX - 140 + 50}
          y={centerPointY + 185}
          style={legendStyle}
        >
          Vy
        </text>
        {this.drawArrow(
          centerPointX - 145 + 100,
          centerPointY + 180,
          0,
          'blue',
          1,
          true
        )}
        <text
          x={centerPointX - 140 + 100}
          y={centerPointY + 185}
          style={legendStyle}
        >
          Vb
        </text>

        {this.drawArrow(
          centerPointX - 145 + 150,
          centerPointY + 180,
          0,
          'red',
          1,
          false
        )}
        <text
          x={centerPointX - 140 + 150}
          y={centerPointY + 185}
          style={legendStyle}
        >
          Ir
        </text>
        {this.drawArrow(
          centerPointX - 145 + 200,
          centerPointY + 180,
          0,
          '#DDB60C',
          1,
          false
        )}
        <text
          x={centerPointX - 140 + 200}
          y={centerPointY + 185}
          style={legendStyle}
        >
          Iy
        </text>
        {this.drawArrow(
          centerPointX - 145 + 250,
          centerPointY + 180,
          0,
          'blue',
          1,
          false
        )}
        <text
          x={centerPointX - 140 + 250}
          y={centerPointY + 185}
          style={legendStyle}
        >
          Ib
        </text>
      </g>
    );
  };
}

export default PhasorDiagram;
